import * as React from 'react'
import { PrimaryDropdownConnected } from './PrimaryDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const PrimaryDropdownExamples = () => {
  return (
    <div className="PrimaryDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <PrimaryDropdownConnected />
      </Provider>
    </div>
  )
}
